// extracted by mini-css-extract-plugin
export default {"container":"FixedFooterDeposits-module_container_c78066","submitButton":"FixedFooterDeposits-module_submitButton_f80494"};